import { Component, OnInit, Input, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { FormControlExFactory } from '../../../core/service/factory/form-control-ex-factory.service';
import { ActionWindowService } from '../../../core/service/action-window.service';
import { MessageService } from '../../../core/service/message.service';
import { BuildingSpaceService } from '../../service/data/building-space.service';
import { BuildingSpace } from '../../model/building-space';
import { Building } from '../../model/building';
import { Subscription } from 'rxjs/internal/Subscription';
import { BuildingSpaceTypeService } from '../../service/data/building-space-type.service';
import { SelectionItem } from '../../../core/component/select/select.component';
import { BuildingSpaceType } from '../../model/building-space-type';

@Component({
    selector: 'app-create-building-space-dialog',
    templateUrl: './create-building-space-dialog.component.html',
    styleUrls: ['./create-building-space-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CreateBuildingSpaceDialogComponent implements OnInit, OnDestroy {
  constructor(
    private _dialogService: ActionWindowService,
    private _dataService: BuildingSpaceService,
    private _messageService: MessageService,
    private _buildingSpaceTypeService: BuildingSpaceTypeService,
    private _fb: FormBuilder,
    private _fcf: FormControlExFactory
  ) {}

  ngOnDestroy(): void {
    if (this.loadSub) this.loadSub.unsubscribe();
    if (this.sub) this.sub.unsubscribe();
  }

  @Input() dataContext: { building: Building };

  form: FormGroup;
  buildingSpaceTypes: SelectionItem[];
  private _buildingSpaceTypes: BuildingSpaceType[];

  cancel() {
    this._dialogService.close();
  }
  private loadSub: Subscription;
  private sub: Subscription = new Subscription();

  ngOnInit() {
    this.form = this._fb.group({
      buildingId: this._fcf.createHidden(this.dataContext.building.id),
      buildingSpaceTypeId: this._fcf.createMandatory('BUILDING_SPACE_TYPE.BUILDING_SPACE_TYPE', null),
      caption: this._fcf.createWithOptions('BUILDING_SPACE.CAPTION', '', { required: true, length: 50 }),
      spaceNumber: this._fcf.createMaxLength('BUILDING_SPACE.SPACE_NUMBER', null, 20),
      area: this._fcf.create('BUILDING_SPACE.AREA', null),
    });
    this.loadSub = this._buildingSpaceTypeService.getList().subscribe(res => {
      this._buildingSpaceTypes = res;
      this.buildingSpaceTypes = res.map(t => new SelectionItem(t.toString(), t.id));
      if (this.buildingSpaceTypes.length) this.form.controls['buildingSpaceTypeId'].setValue(this.buildingSpaceTypes[0].value);
    });
    this.sub.add(
      this.form.controls['buildingSpaceTypeId'].valueChanges.subscribe(val => {
        if (val && this._buildingSpaceTypes) {
          let spaceType = this._buildingSpaceTypes.find(t => t.id === val);
          if (spaceType) {
            if (!this.form.controls['caption'].value || this.form.controls['caption'].value === this._selectedSpaceTypeCaption)
              this.form.controls['caption'].setValue(spaceType.caption);
            this._selectedSpaceTypeCaption = spaceType.caption;
          }
        }
      })
    );
  }

  private _selectedSpaceTypeCaption: string;

  private _working = false;
  onSubmit() {
    if (this._working) return;
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    this._working = true;

    this._dataService.add(new BuildingSpace(this.form.value)).subscribe(
      res => {
        this._messageService.showSuccess();
        this._dialogService.complete(res);
      },
      () => {
        this._working = false;
      }
    );
  }
}
